import React, { useState, useEffect } from "react";
const CandleChart: React.FC = () => {
  const [symbol, setSymbol] = useState<string>("OANDA:EURUSD");

  useEffect(() => {
    if (!window.TradingView) {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/tv.js";
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        createTradingViewWidget(symbol);
      };
    } else {
      createTradingViewWidget(symbol);
    }

    return () => {
      const scriptTags = document.querySelectorAll('script[src="https://s3.tradingview.com/tv.js"]');
      scriptTags.forEach((scriptTag) => scriptTag.remove());
    };
  }, [symbol]);

  // const createTradingViewWidget = (symbol: string) => {
  //   new window.TradingView.widget({
  //     width: "100%",
  //     height: "400",
  //     symbol: symbol,
  //     interval: "D",
  //     timezone: "America/New_York",
  //     theme: "dark",
  //     style: "1",
  //     locale: "en",
  //     range: "12M",
  //     container_id: "tradingview-widget-container",
  //     // custom_css_url: "https://yourdomain.com/path/to/custom.css",
  //   });
  // };
  const createTradingViewWidget = (symbol: string) => {
    // Add the margin-bottom directly to the container
    const container = document.getElementById("tradingview-widget-container");
    if (container) {
      container.style.marginBottom = "38px";
      container.style.marginTop = "27px"
    }
  
    new window.TradingView.widget({
      width: "100%",
      height: "415",
      symbol: symbol,
      interval: "D",
      timezone: "America/New_York",
      theme: "dark",
      style: "1",
      locale: "en",
      range: "12M",
      container_id: "tradingview-widget-container",
    });
  };
  

  const handleSymbolChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSymbol(e.target.value);
  };

  return (
    <div style={{ maxWidth: "900px", margin: "auto" }}>
      <div style={{ marginBottom: "10px" }} className="chart_header">
        <label htmlFor="forex-pair" style={{ marginRight: "10px" }}>
          Select Forex Pair:
        </label>
        <select
          id="forex-pair"
          value={symbol}
          onChange={handleSymbolChange}
          style={{ padding: "8px", fontSize: "14px" }}
        >
          <option value="OANDA:EURUSD">EUR/USD</option>
          <option value="OANDA:GBPUSD">GBP/USD</option>
          <option value="OANDA:USDJPY">USD/JPY</option>
          <option value="OANDA:USDCHF">USD/CHF</option>
          <option value="OANDA:AUDUSD">AUD/USD</option>
          <option value="OANDA:NZDUSD">NZD/USD</option>
        </select>
      </div>

      {/* TradingView Widget */}
      <div
        id="tradingview-widget-container"
        style={{
          width: "100%",
          height: "400px",
          backgroundColor: "#000000",
        }}
      />
    </div>
  );
};

export default CandleChart;
